const user_data = [
	{
		id: 'avatar_1',
		title: 'NFT Funny Cat',
		image: '/images/avatars/avatar_1.jpg',
		icon: true,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_2',
		title: 'Cryptopank',
		image: '/images/avatars/avatar_2.jpg',
		icon: true,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_3',
		title: 'Prince Ape Planet',
		image: '/images/avatars/avatar_3.jpg',
		icon: false,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_4',
		title: 'Hey Mrsmeseks',
		image: '/images/avatars/avatar_4.jpg',
		icon: true,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_5',
		title: 'Bored Bunny',
		image: '/images/avatars/avatar_5.jpg',
		icon: false,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_6',
		title: 'Wow Frens',
		image: '/images/avatars/avatar_6.jpg',
		icon: false,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_7',
		title: 'Origin Morish',
		image: '/images/avatars/avatar_7.jpg',
		icon: true,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: ' avatar_8',
		title: 'Superdo',
		image: '/images/avatars/avatar_8.jpg',
		icon: true,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_9',
		title: 'NFT stars',
		image: '/images/avatars/avatar_9.jpg',
		icon: false,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_10',
		title: 'Asumitsu',
		image: '/images/avatars/avatar_10.jpg',
		icon: true,
		userId: 'Origin Morish',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_11',
		title: 'Pank Skull',
		image: '/images/avatars/avatar_11.jpg',
		icon: false,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_12',
		title: 'Lazy Panda',
		image: '/images/avatars/avatar_12.jpg',
		icon: false,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_13',
		title: 'Arcahorizons',
		image: '/images/avatars/avatar_13.jpg',
		icon: true,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_14',
		title: 'Sussygirl',
		image: '/images/avatars/avatar_14.jpg',
		icon: false,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_15',
		title: 'Smilebin',
		image: '/images/avatars/avatar_15.jpg',
		icon: true,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
	{
		id: 'avatar_16',
		title: 'Pankysmoke',
		image: '/images/avatars/avatar_16.jpg',
		icon: false,
		userId: '0x7a86c0b064171007716bbd6af96676935799a63e',
		joinYear: '2019',
		text: 'Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.',
		coverPhoto: '/images/user/banner.jpg',
	},
];

export default user_data;
